import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AssembleaView } from 'src/app/model/assemblea-view';
import { AttachmentsService } from 'src/app/services/attachments/attachments.service';

@Component({
  selector: 'app-decreti-approvazione',
  templateUrl: './decreti-approvazione.component.html',
  styleUrls: ['./decreti-approvazione.component.scss']
})
export class DecretiApprovazioneComponent implements OnInit, AfterViewInit {
  constructor(private attachmentsService: AttachmentsService) {
    this.dataSource = new MatTableDataSource();
  }

  dataSource: MatTableDataSource<AssembleaView>;
  displayedColumns: string[] = [
    "dataDecreto",
    "nomeDecreto",
    "azioni",
  ];
  totalItems: number = 0;
  pageSize: number = 10; // Imposta la dimensione della pagina iniziale
  pageSizeOptions: number[] = [5, 10, 25, 100]; // Opzioni di dimensione pagina
  pageIndex = 0;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  currentPage: number;

  public ngAfterViewInit(): void {
    this.currentPage = 0;
    this.pageSize = 10;
    this.dataSource.sort = this.sort;
  }

  public onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.loadDatatable();
  }

  ngOnInit(): void {
    this.loadDatatable();
  }

  loadDatatable() {

    this.attachmentsService.ricercaDecreti(this.pageIndex, this.pageSize).subscribe({
      next: (response: any) => {
        this.totalItems = response.result.count;
        this.dataSource = new MatTableDataSource(response.result.listaAssemblea);
        this.dataSource.sort = this.sort;
      }
    })
  }

  downloadDecreto(id: any) {
    console.log("id",id);
    let data = {
      valore: id
    }
    this.attachmentsService.downloadDocumentoHomePage(data).subscribe(
      (data: any) => {
        let fileName: string = "Decreto.pdf";
        this.attachmentsService.downloadService(data, fileName);
      }
    )
  }

  onPaginateChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.loadDatatable();
  }

}
